import { useState } from "react";
import { CheckboxCard } from "shared/components";
import { toast } from "react-toastify";
import { CombinedIncomeSubStep } from "../../../constants";
import { CombinedIncomeLayout } from "../components/Layout";
import { useCombinedIncome } from "../context";
import { getErrorMessage } from "utils/error";

const INCOME_BULLETS = [
  "Has a job",
  "Is self-employed",
  "Receives retirement benefits (pension, Social Security)",
  "Receives government assistance (not including housing assistance)",
  "Has a job offer starting soon"
];

export const IncomeStatusStep = () => {
  const { updateStepMutation } = useCombinedIncome();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSelect = async (hasIncome: boolean) => {
    if (isProcessing) return;

    setIsProcessing(true);
    try {
      await updateStepMutation.mutateAsync({
        lastStep: hasIncome
          ? CombinedIncomeSubStep.SelectIncomeType
          : CombinedIncomeSubStep.NoIncomeReason
      });
    } catch (error) {
      toast.error(getErrorMessage(error) || "Failed to proceed");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <CombinedIncomeLayout
      title="Do any of these apply to the applicant?"
      subtitle='Choose "Yes" if at least one applies'
    >
      <ul className="mb-[18px] list-disc pl-5 flex flex-col gap-2 text-sm text-content-500">
        {INCOME_BULLETS.map((bullet) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>
      <div className="flex w-full gap-2">
        <CheckboxCard
          checked={false}
          id="yes"
          label="Yes"
          name="yes"
          wrapperClassName="w-full"
          className="p-6"
          onChange={() => handleSelect(true)}
        />
        <CheckboxCard
          checked={false}
          id="no"
          label="No"
          name="no"
          wrapperClassName="w-full"
          className="p-6"
          onChange={() => handleSelect(false)}
        />
      </div>
    </CombinedIncomeLayout>
  );
};
